'use client';

import { osanoShowDialog } from '@/utils/osano/osano-cookie-helper';

type CookieConsentButtonProps = {
    linkText: string;
    dataTestId: string;
};

export const CookieConsentButton = ({ linkText, dataTestId }: CookieConsentButtonProps) => (
    <button
        type="button"
        data-test-id={dataTestId}
        className="footer-links__section__link footer-links__section__link--button"
        onClick={osanoShowDialog}>
        {linkText}
    </button>
);
